import React from 'react';
import ListViewSearch from './ListViewSearch';
import ListViewLooks from './ListViewLooks';
import ListViewExportButtons from './ListViewExportButtons';
import sAction from 'sAction';

export default function ListViewMenu(props) {
    const breadcrumbData = sAction.breadcrumb(props.data.modul);
    const title = breadcrumbData[breadcrumbData.length -1]['label'] || '';

    return (
        <React.Fragment>
            {/* <div className="listViewActions"> */}
            <div className="title">{title}</div>
            <div className="divider-responsive"></div>
            <ListViewSearch data={props.data.filter} module={props.data.modul} prefix={props.prefix}/>
            {/* </div>
      <div className="listViewActions2"> */}
            {/* <ListViewLooks data={props.data.savedSearch} module={props.data.modul} prefix={props.prefix}/> */}
            {/* // na AON portale skryto
            <div className="exportBtns">
                <ListViewExportButtons module={props.data.modul} prefix={props.prefix} />
            </div> */}
            {/* </div> */}
        </React.Fragment>
    );
}
